import { render } from "./StaffPctChart.vue?vue&type=template&id=565bc6fd&scoped=true"
import script from "./StaffPctChart.vue?vue&type=script&lang=js"
export * from "./StaffPctChart.vue?vue&type=script&lang=js"

import "./StaffPctChart.vue?vue&type=style&index=0&id=565bc6fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565bc6fd"]])

export default __exports__